import { render } from "./Step.vue?vue&type=template&id=88afa330&scoped=true&bindings={}"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"

import "./Step.vue?vue&type=style&index=0&id=88afa330&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-88afa330"

export default script